/* tslint:disable */
/* eslint-disable */
/**
 * crm
 * crm
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResidentPreArrivalFindAllResponse } from './ResidentPreArrivalFindAllResponse';
import {
    ResidentPreArrivalFindAllResponseFromJSON,
    ResidentPreArrivalFindAllResponseFromJSONTyped,
    ResidentPreArrivalFindAllResponseToJSON,
} from './ResidentPreArrivalFindAllResponse';

/**
 * 
 * @export
 * @interface FindAllPreArrivalResidents200Response
 */
export interface FindAllPreArrivalResidents200Response {
    /**
     * 
     * @type {ResidentPreArrivalFindAllResponse}
     * @memberof FindAllPreArrivalResidents200Response
     */
    data?: ResidentPreArrivalFindAllResponse;
}

/**
 * Check if a given object implements the FindAllPreArrivalResidents200Response interface.
 */
export function instanceOfFindAllPreArrivalResidents200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllPreArrivalResidents200ResponseFromJSON(json: any): FindAllPreArrivalResidents200Response {
    return FindAllPreArrivalResidents200ResponseFromJSONTyped(json, false);
}

export function FindAllPreArrivalResidents200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllPreArrivalResidents200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ResidentPreArrivalFindAllResponseFromJSON(json['data']),
    };
}

export function FindAllPreArrivalResidents200ResponseToJSON(value?: FindAllPreArrivalResidents200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ResidentPreArrivalFindAllResponseToJSON(value.data),
    };
}

